import { render, staticRenderFns } from "./xskAddpick.vue?vue&type=template&id=c8342164&scoped=true"
import script from "./xskAddpick.vue?vue&type=script&lang=js"
export * from "./xskAddpick.vue?vue&type=script&lang=js"
import style0 from "./xskAddpick.vue?vue&type=style&index=0&id=c8342164&prod&lang=css"
import style1 from "./xskAddpick.vue?vue&type=style&index=1&id=c8342164&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8342164",
  null
  
)

export default component.exports